import { useState, useEffect } from "react";
import { Lightbulb, Shuffle } from "lucide-react";
import { FACTS } from "@/lib/vibesContent";

export default function LearningCard() {
  const [, tick] = useState(0);
  const [offset, setOffset] = useState(0);
  useEffect(() => { const iv = setInterval(() => tick((t) => t + 1), 60000); return () => clearInterval(iv); }, []);
  const slot = Math.floor(Date.now() / 3600000);
  const fact = FACTS[(slot + offset) % FACTS.length];
  const minsLeft = 60 - (Math.floor(Date.now() / 60000) % 60);
  return (
    <div className="space-y-2 py-1">
      <div className="flex items-center gap-2">
        <Lightbulb className="h-5 w-5 text-sky-500" />
        <span className="font-mono text-[10px] uppercase tracking-wider opacity-60">today you learn</span>
      </div>
      <p data-testid="learning-title" className="font-display text-base font-bold leading-snug">{fact.t}</p>
      <p data-testid="learning-detail" className="text-sm leading-relaxed opacity-85">{fact.d}</p>
      <div className="flex items-center justify-between text-[10px] font-mono uppercase tracking-wider opacity-50">
        <span data-testid="learning-countdown">next in {minsLeft}m</span>
        <button data-testid="learning-shuffle" onClick={() => setOffset((o) => o + 1)}
          className="flex items-center gap-1 rounded-full px-2 py-0.5 transition-colors hover:bg-black/10">
          <Shuffle className="h-3 w-3" /> another
        </button>
      </div>
    </div>
  );
}
